import * as React from "react";
import { Collapse } from "react-collapse";
import Container from "./styled";

class DropdownItem extends React.Component {
  render() {
    return (
      <Container>
        <button
          className={this.props.isActive ? "headerBarOpen" : "headerBarClose"}
          onClick={this.props.clickFunction}
        >
          <h4>{this.props.title}</h4>
          <img
            id="buttonIcon"
            alt={this.props.isActive ? "Cerrar" : "Abrir"}
            src={
              this.props.isActive
                ? "images/home/preguntas/accordion/arrowUp.svg"
                : "images/home/preguntas/accordion/plus.svg"
            }
          ></img>
          {/* {this.props.isActive != true ? "Abrir" : "Cerrar"} */}
        </button>
        <Collapse isOpened={this.props.isActive}>
          <div className="displayText">
            <hr className={this.props.isActive != true && "hrClose"}></hr>
            <p>{this.props.children}</p>
          </div>
        </Collapse>
      </Container>
    );
  }
}

export default DropdownItem;
